export const SKILL_GRADES = {
  S: { min: 95, max: 100, label: 'S' },
  A: { min: 80, max: 94, label: 'A' },
  B: { min: 65, max: 79, label: 'B' },
  C: { min: 45, max: 64, label: 'C' },
  D: { min: 25, max: 44, label: 'D' },
  E: { min: 11, max: 24, label: 'E' },
  F: { min: 1, max: 10, label: 'F' }
}

export const WEIGHT_CATEGORIES = [
  { min: 45, max: 50, label: 'Featherweight' },
  { min: 51, max: 57, label: 'Lightweight' },
  { min: 58, max: 63, label: 'Welterweight' },
  { min: 64, max: 68, label: 'Middleweight' },
  { min: 69, max: 72, label: 'Cruiserweight' },
  { min: 73, max: 80, label: 'Heavyweight' }
]

export class Jockey {
  constructor(name, region) {
    this.id = crypto.randomUUID();
    this.name = name;
    this.region = region;
    this.weight = Math.floor(Math.random() * 31) + 45;
    this.skill = Math.floor(Math.random() * 100) + 1;
    this.recentForm = Array(5).fill(null);
  }


  get skillGrade() {
    return Object.values(SKILL_GRADES).find(
      grade => this.skill >= grade.min && this.skill <= grade.max
    )?.label || 'F'
  }

  get weightCategory() {
    return WEIGHT_CATEGORIES.find(
      category => this.weight >= category.min && this.weight <= category.max
    )?.label || 'Unknown'
  }

  updateForm(position) {
    this.recentForm = [position, ...this.recentForm.slice(0, 4)]
  }
  get averageForm() {
    const validResults = this.recentForm.filter(pos => pos !== null)
    if (validResults.length === 0) return null
    return validResults.reduce((a, b) => a + b, 0) / validResults.length
  }

  get formDisplay() {
    return this.recentForm.map(pos => pos === null ? '-' : pos).join(' ')
  }


  toJSON() {
    return {
      id: this.id,
      name: this.name,
      weight: this.weight,
      skill: this.skill,
      recentForm: this.recentForm,
      averageForm: this.averageForm,
      formDisplay: this.formDisplay,
      region: this.region
    }
  }
}
